import React from "react";
import { Controller } from "react-hook-form";

const EmailInput = ({
  name,
  control,
  label,
  placeholder,
  rules = {},
  onValueChange,
  className = {},
}) => {
  const emailRules = {
    pattern: { value: /\S+@\S+\.\S+/, message: "Invalid email" },
    ...rules,
  };

  return (
    <Controller
      name={name}
      control={control}
      rules={emailRules}
      render={({
        field: { value, onChange, onBlur },
        fieldState: { error },
      }) => (
        <>
          <input
            type="email"
            value={value || ""}
            onChange={(e) => {
              onChange(e.target.value);
              onValueChange && onValueChange(e.target.value);
            }}
            id={`email-${name}`}
            onBlur={onBlur}
            placeholder={placeholder}
            className={className}
          />

          {label && (
            <label htmlFor={`email-${name}`} className="text-body-b2">
              Enter email
            </label>
          )}
        </>
      )}
    />
  );
};

export default EmailInput;
